export const ScreensKey: any = {
    Participants: 'participant_list'
}